import { Button, Col, Form, Input, Row } from "antd";
import { useCallback, useState, FocusEvent } from "react";
import {
  CapsLockHint,
  useToggleCapsLock,
} from "../../../components/CapsLockHint";
import { UsefulLinks } from "../UsefulLinks";
import { useValidateOnBlur } from "../../../lib/hooks/validateOnBlur";
import { useCredsRules } from "../../../lib/hooks/useCredsRules";

type LoginFormProps = {
  data: any;
  onLoginButtonClicked: (value: any) => Promise<any>;
};

export const LoginForm = ({ data, onLoginButtonClicked }: LoginFormProps) => {
  const [form] = Form.useForm();

  const [isFormDisabled, setIsFormDisabled] = useState<boolean>(false);

  const [validateOnBlur] = useValidateOnBlur(form);

  const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);

  const [isCapsLockOn, onPasswordType] = useToggleCapsLock(false);

  const onLogIn = async (values: any) => {
    try {
      setIsFormDisabled(true);
      await onLoginButtonClicked(values);
      setIsFormDisabled(false);
    } catch (err: any) {
      setIsFormDisabled(false);
    }
  };

  const { passwordRules, usernameRules } = useCredsRules();

  const onUsernameBlur = useCallback(
    (e: FocusEvent<HTMLInputElement, Element>) => validateOnBlur(e, "username"),
    [validateOnBlur],
  );

  const onPasswordBlur = useCallback(
    (e: FocusEvent<HTMLInputElement, Element>) => validateOnBlur(e, "password"),
    [validateOnBlur],
  );

  return (
    <>
      <Row>
        <Col span={12} offset={6}>
          <div className="greeting__container d-flex mt-16 justify-space-around mb-10">
            <h1 className="header">Welcome</h1>
          </div>
        </Col>
      </Row>
      <Row className="justify-center mx-4">
        <Col className="login-form">
          <Row className="d-flex justify-center">
            <Col className="form__container">
              <Form
                form={form}
                layout="vertical"
                onFinish={onLogIn}
                autoComplete="off"
                initialValues={data}
                requiredMark={false}
                disabled={isFormDisabled}
              >
                <Form.Item
                  name="username"
                  label="Email or Username"
                  className="mb-5"
                  rules={usernameRules}
                >
                  <Input size="large" onBlur={onUsernameBlur} />
                </Form.Item>
                <div className="position-relative mb-8">
                  <Form.Item
                    name="password"
                    label="Password"
                    rules={passwordRules}
                  >
                    <Input.Password
                      size="large"
                      visibilityToggle={{
                        visible: isPasswordVisible,
                        onVisibleChange: setIsPasswordVisible,
                      }}
                      onKeyUp={onPasswordType}
                      onBlur={onPasswordBlur}
                    />
                  </Form.Item>

                  {isCapsLockOn && <CapsLockHint />}
                </div>

                <Form.Item>
                  <Button
                    type="primary"
                    shape="round"
                    size="large"
                    htmlType="submit"
                    block
                    loading={isFormDisabled}
                  >
                    Log in
                  </Button>
                </Form.Item>
              </Form>

              <UsefulLinks />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
